import React from 'react';
import { Label as UiLabel, LabelProps } from '@make-software/cspr-ui';

export const Label = (props: Omit<LabelProps, 'size'>) => (
  <UiLabel size={2} lineHeight={'xxs'} {...props} />
);
